var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-old-to-new-detail',{staticClass:"pt-old-to-new-detail__page",attrs:{"id":_vm.id,"type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }